import React from 'react';
import { useNavigate } from 'react-router-dom';

function Logout() {
  const navigate = useNavigate(); // Hook to navigate programmatically

  React.useEffect(() => {
    // Perform logout actions
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
    
    // Use window.location.replace for forceful navigation
    window.location.replace('/');
  }, []);
  

  return null; // No UI is needed for the logout component
}

export default Logout;
